import { CSSProperties, ReactNode } from "react";

import { css, cx } from "simplydo/react/styled";

import type { UISize } from "../utils/UIContext";

const subheader = css`
  display: block;
  font-weight: normal;
  padding: 0;
  margin: 0.2rem 0 0;
  font-size: 1rem;
  line-height: 1.3em;

  &.small {
    font-size: 0.875rem;
  }

  &.medium {
    font-size: 1rem;
  }

  &.large {
    font-size: 1.125rem;
  }

  > p {
    margin-bottom: 0.5em;
  }
`;

type SubheaderProps = {
  children?: ReactNode;
  className?: string;
  size?: UISize;
  style?: CSSProperties;
};

export const Subheader = ({
  children,
  className,
  size = "medium",
  style,
}: SubheaderProps) => (
  <span className={cx(subheader, size, className)} style={style}>
    {children}
  </span>
);
